import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { products, categories } from "../data/products";
import ProductCard from "./ProductCard";

const ALL = "all";

export default function CatalogSection({ refProp, initialCategory, onViewProduct }) {
  const [active, setActive] = useState(ALL);

  useEffect(() => {
    if (initialCategory && initialCategory !== active) {
      const match = categories.find(c => c.id === initialCategory || c.label.toLowerCase().includes(initialCategory));
      if (match) setActive(match.id);
    }
  }, [initialCategory]);

  const filtered = active === ALL ? products : products.filter(p => p.category === active);

  return (
    <section className="catalog-section" ref={refProp} id="catalog">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div className="section-eyebrow">THE COLLECTION</div>
          <h2 className="section-title">Biomedical <em>Excellence</em></h2>
          <p className="section-sub">
            Precision instruments and assistive devices, curated for Nepal's healthcare needs
          </p>
        </motion.div>

        <div className="filter-bar">
          <button
            className={`filter-pill ${active === ALL ? "active" : ""}`}
            onClick={() => setActive(ALL)}
          >
            All
          </button>
          {categories.map(c => (
            <button
              key={c.id}
              className={`filter-pill ${active === c.id ? "active" : ""}`}
              onClick={() => setActive(c.id)}
            >
              {c.label}
            </button>
          ))}
        </div>

        <motion.div className="product-grid" layout>
          <AnimatePresence mode="popLayout">
            {filtered.map((product, i) => (
              <motion.div
                key={product.id}
                layout
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.95 }}
                transition={{ duration: 0.4 }}
              >
                <ProductCard product={product} index={i} onView={onViewProduct} />
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>

        <div className="catalog-count">
          Showing {filtered.length} of {products.length} products
        </div>
      </div>
    </section>
  );
}
